import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

export class FilterModel<T> {
    constructor(public name: string,
                public matcher: (v: T) => boolean,
                public selected: boolean = true) {
    }

    matches(vehicle: T) {
        if (!this.selected) return false;
        return this.matcher(vehicle);
    }
}

let nextId = 1;

@Component({
    selector: 'app-filter-checkbox-tree',
    templateUrl: './filter-checkbox-tree.component.html',
    styles: [':host{ display: block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCheckboxTreeComponent<T> implements OnInit {
    @HostBinding('class')
    clazz = 'filter-box';

    id = nextId++ + '-';

    @Input()
    title: string;
    @Input()
    allTitle = 'All';
    @Input()
    models: FilterModel<T>[] = [];
    @Output() modelsChange = new EventEmitter<FilterModel<T>[]>();

    seeMore = false;

    constructor() {
    }

    ngOnInit() {
    }

    setAllSelected(values: FilterModel<T>[], selected: boolean) {
        for (let value of values) {
            value.selected = selected;
        }
        this.modelsChange.emit([...this.models]);
    }

    checkChanged() {
        this.modelsChange.emit([...this.models]);
    }
}
